(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gawakie-testimonials"] && !Shopify.designMode) return;
  try {
    
  class GwkTestimonialsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.viewport = this.querySelector('[data-gwk-testimonials-viewport]');
      this.previousButton = this.querySelector('[data-gwk-testimonials-prev]');
      this.nextButton = this.querySelector('[data-gwk-testimonials-next]');

      if (!this.viewport) return;

      this.handleScroll = this.updateControls.bind(this);
      this.handleKeydown = this.onKeydown.bind(this);
      this.handlePrevious = () => this.scrollByStep(-1);
      this.handleNext = () => this.scrollByStep(1);
      this.handleResize = () => this.updateControls();

      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      this.viewport.addEventListener('keydown', this.handleKeydown);
      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.viewport);
      } else {
        window.addEventListener('resize', this.handleResize);
      }

      requestAnimationFrame(() => this.updateControls());
    }

    disconnectedCallback() {
      this.viewport?.removeEventListener('scroll', this.handleScroll);
      this.viewport?.removeEventListener('keydown', this.handleKeydown);
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.handleResize);
    }

    onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.scrollByStep(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.scrollByStep(1);
      }
    }

    getStepSize() {
      const firstCard = this.querySelector('.gwk-testimonials__slide-card');
      const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : this.viewport.clientWidth;
      const styles = getComputedStyle(this);
      const gap = parseFloat(styles.getPropertyValue('--gwk-testimonials-gap')) || 0;

      return cardWidth + gap;
    }

    scrollByStep(direction) {
      this.viewport.scrollBy({
        left: this.getStepSize() * direction,
        behavior: 'smooth',
      });
    }

    updateControls() {
      const maxScrollLeft = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const currentScrollLeft = Math.max(0, this.viewport.scrollLeft);
      const canScroll = maxScrollLeft > 2;

      this.dataset.scrollable = canScroll ? 'true' : 'false';

      if (this.previousButton) {
        this.previousButton.disabled = !canScroll || currentScrollLeft <= 1;
      }

      if (this.nextButton) {
        this.nextButton.disabled = !canScroll || currentScrollLeft >= maxScrollLeft - 1;
      }
    }
  }

  if (!customElements.get('gwk-testimonials-carousel')) {
    customElements.define('gwk-testimonials-carousel', GwkTestimonialsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
